var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.loading
      ? _c("div", { staticClass: "loading-overlay" }, [_vm._m(0)])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "p-3" }, [
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-center mb-3",
        },
        [
          _c("h3", { staticClass: "mb-0" }, [_vm._v("Update Regno")]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: { type: "button", disabled: _vm.loading },
              on: { click: _vm.openHistory },
            },
            [
              _c("i", { staticClass: "fa fa-history" }),
              _vm._v("\n                History Update\n            "),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "card mb-3" }, [
        _c("div", { staticClass: "card-header bg-primary text-white" }, [
          _vm._v("\n                Pencarian Pasien\n            "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-4" }, [
              _c("label", [_vm._v("Medrec / Nama")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.search,
                    expression: "filter.search",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.filter.search },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.getAllPasien.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.filter, "search", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2 d-flex align-items-end" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button", disabled: _vm.loading },
                  on: { click: _vm.getAllPasien },
                },
                [
                  _vm._v(
                    "\n                            Cari\n                        "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "modal-detail", tabindex: "-1" },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-xl" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "row mb-3" }, [
                  _c("div", { staticClass: "col-md-4" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.detail_search,
                          expression: "detail_search",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Cari Regno..." },
                      domProps: { value: _vm.detail_search },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.detail_search = $event.target.value
                          },
                          _vm.filterRegno,
                        ],
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", { staticClass: "table table-bordered" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.detail_regno_filtered, function (item) {
                          return _c("tr", { key: item.Regno }, [
                            _c("td", [_vm._v(_vm._s(item.Regno))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.Regdate))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.total_data))]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-warning btn-sm me-2",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.loading,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openUpdate(item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                                Merge Regno\n                                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-info btn-sm text-white",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.loading,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openUpdateOnly(item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                                Ganti Regno Saja\n                                            "
                                  ),
                                ]
                              ),
                            ]),
                          ])
                        }),
                        _vm._v(" "),
                        _vm.detail_regno_filtered.length === 0
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "text-center",
                                  attrs: { colspan: "4" },
                                },
                                [
                                  _vm._v(
                                    "\n                                            Data tidak ditemukan\n                                        "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "modal-update", tabindex: "-1" },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-lg" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "mb-3" }, [
                  _c("label", [_vm._v("Regno Lama")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.old_regno,
                        expression: "form.old_regno",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", readonly: "" },
                    domProps: { value: _vm.form.old_regno },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.form, "old_regno", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-3" }, [
                  _c("label", [_vm._v("Regno Tujuan")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mb-2" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.regno_option_search,
                          expression: "regno_option_search",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        placeholder: "Cari Regno Tujuan...",
                      },
                      domProps: { value: _vm.regno_option_search },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) return
                            _vm.regno_option_search = $event.target.value
                          },
                          _vm.filterRegnoOption,
                        ],
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.new_regno,
                          expression: "form.new_regno",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { size: "8" },
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "new_regno",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v("Pilih Regno"),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.regno_options_filtered, function (item) {
                        return _c(
                          "option",
                          {
                            key: item.Regno,
                            attrs: {
                              disabled: item.Regno === _vm.form.old_regno,
                            },
                            domProps: { value: item.Regno },
                          },
                          [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(item.Regno) +
                                "\n                                "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "alert alert-warning" }, [
                  _vm._v(
                    "\n                            Seluruh data pada tabel berikut akan dipindahkan\n                            ke Regno tujuan.\n                        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", { staticClass: "table table-bordered" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.preview_data, function (item) {
                          return _c("tr", { key: item.table }, [
                            _c("td", [_vm._v(_vm._s(item.table))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.count))]),
                          ])
                        }),
                        _vm._v(" "),
                        _vm.preview_data.length === 0
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "text-center",
                                  attrs: { colspan: "2" },
                                },
                                [
                                  _vm._v(
                                    "\n                                            Tidak ada data\n                                        "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c("tr", [
                        _c("th", [_vm._v("Total")]),
                        _vm._v(" "),
                        _c("th", [_vm._v(_vm._s(_vm.grand_total))]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-bs-dismiss": "modal" },
                  },
                  [
                    _vm._v(
                      "\n                            Batal\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button", disabled: _vm.loading },
                    on: { click: _vm.saveUpdate },
                  },
                  [
                    _vm._v(
                      "\n                            Merge Regno\n                        "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "modal-update-only", tabindex: "-1" },
        },
        [
          _c("div", { staticClass: "modal-dialog" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(6),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "alert alert-info" }, [
                  _vm._v(
                    "\n                            Hanya kolom Regno pada tabel Register yang akan\n                            diubah. Tabel lainnya tidak akan diperbarui.\n                        "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-3" }, [
                  _c("label", [_vm._v("Regno Lama")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form_only.old_regno,
                        expression: "form_only.old_regno",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", readonly: "" },
                    domProps: { value: _vm.form_only.old_regno },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.form_only,
                          "old_regno",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-3" }, [
                  _c("label", [_vm._v("Regno Baru")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.form_only.new_regno,
                        expression: "form_only.new_regno",
                        modifiers: { trim: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", placeholder: "Masukkan Regno baru" },
                    domProps: { value: _vm.form_only.new_regno },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.saveUpdateOnly.apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.form_only,
                          "new_regno",
                          $event.target.value.trim()
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-bs-dismiss": "modal" },
                  },
                  [
                    _vm._v(
                      "\n                            Batal\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info text-white",
                    attrs: { type: "button", disabled: _vm.loading },
                    on: { click: _vm.saveUpdateOnly },
                  },
                  [
                    _vm._v(
                      "\n                            Ganti Regno\n                        "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: { id: "modal-history", tabindex: "-1" },
        },
        [
          _c("div", { staticClass: "modal-dialog modal-xl" }, [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(7),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "table-responsive" }, [
                  _c("table", { staticClass: "table table-bordered" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _vm._l(_vm.history_data, function (item) {
                          return _c("tr", { key: item.id }, [
                            _c("td", [_vm._v(_vm._s(item.tanggal_update))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.medrec))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.old_regno))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.new_regno))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(item.nama))]),
                            _vm._v(" "),
                            _c("td", [
                              item.rollback_at
                                ? _c(
                                    "span",
                                    { staticClass: "badge bg-success" },
                                    [
                                      _vm._v(
                                        "\n                                                Rollback\n                                            "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "badge bg-warning" },
                                    [
                                      _vm._v(
                                        "\n                                                Active\n                                            "
                                      ),
                                    ]
                                  ),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              !item.rollback_at
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-danger btn-sm",
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.loading,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.rollback(item)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                                Rollback\n                                            "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "badge bg-secondary" },
                                    [
                                      _vm._v(
                                        "\n                                                Selesai\n                                            "
                                      ),
                                    ]
                                  ),
                            ]),
                          ])
                        }),
                        _vm._v(" "),
                        _vm.history_data.length === 0
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "text-center",
                                  attrs: { colspan: "7" },
                                },
                                [
                                  _vm._v(
                                    "\n                                            History belum tersedia\n                                        "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading-content" }, [
      _c("div", {
        staticClass: "spinner-border text-primary",
        attrs: { role: "status" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "mt-3" }, [_vm._v("Mohon tunggu...")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header bg-primary text-white" }, [
        _vm._v("Data Pasien"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { attrs: { id: "table-regno" } }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("Detail Regno")]),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn-close",
        attrs: { type: "button", "data-bs-dismiss": "modal" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Regno")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tanggal")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total Data")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "280" } }, [_vm._v("Action")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("Merge Regno")]),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn-close",
        attrs: { type: "button", "data-bs-dismiss": "modal" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Tabel")]),
        _vm._v(" "),
        _c("th", [_vm._v("Jumlah Data")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [
        _vm._v("Ganti Nomor Regno Saja"),
      ]),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn-close",
        attrs: { type: "button", "data-bs-dismiss": "modal" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [
        _vm._v("History Update Regno"),
      ]),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn-close",
        attrs: { type: "button", "data-bs-dismiss": "modal" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Tanggal")]),
        _vm._v(" "),
        _c("th", [_vm._v("Medrec")]),
        _vm._v(" "),
        _c("th", [_vm._v("Regno Lama")]),
        _vm._v(" "),
        _c("th", [_vm._v("Regno Baru")]),
        _vm._v(" "),
        _c("th", [_vm._v("User")]),
        _vm._v(" "),
        _c("th", [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "120" } }, [_vm._v("Action")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }